<div class="container">
  <div
    class="shadower"
    *ngIf="shadower"
  >
    <mat-icon svgIcon="face_masked"></mat-icon><span class="name">{{ shadower.fullName }}</span>
    <button
      merriNoFocusLink
      class="blank-button"
      (click)="onLinkClick($event)"
      #linkButton
      matTooltip="Shareable shadow login link to this page"
      matTooltipShowDelay="1000"
    >
      <mat-icon svgIcon="external_link"></mat-icon>
    </button>
  </div>
  <div
    class="user"
    *ngIf="user"
  >
    <span class="name">{{ user.fullName }}</span>
  </div>
</div>
